import { Input } from "./input";

export class Textarea extends Input {
  constructor(domElem) {
    super(domElem, Textarea.className);
  }

  static className = "textarea";
  static instances = {};

  static init() {
    document.querySelectorAll(`.${Textarea.className}`).forEach((el) => {
      return new Textarea(el);
    });
  }
}
